import React from 'react';

const PinIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="35"
      viewBox="0 0 30 35"
      {...props}
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="2">
        <path
          fill="#FFF"
          d="M16.82 11.531l.88-3.14-.25-2.403-4.7-3.117-3.488.469L6.59 6.5l-.13 3.23v-.02.02c.04.23.09.461.161.7.2.672.48 1.332.809 1.968.441.891.968 1.743 1.468 2.563.34.55.692 1.098 1.043 1.64.66 1.008 1.329 2 1.97 3.02.609-.96 1.25-1.902 1.87-2.86.39-.59.778-1.19 1.149-1.8.59-.973 1.218-1.992 1.71-3.063.07-.117.13-.25.18-.367l.02-.05"
        ></path>
        <path
          fill="#533019"
          d="M11.922 20.77l-.524-.829c-.43-.68-.878-1.363-1.32-2.02-.219-.331-.437-.66-.648-.991a80.984 80.984 0 01-1.051-1.66l-.02-.032c-.5-.816-1.03-1.668-1.48-2.566-.379-.742-.66-1.422-.848-2.07a5.85 5.85 0 01-.18-.782l-.011-.09.34-.011-.34-.008.129-3.45 2.972-3.5 3.95-.542 5.14 3.41.29 2.812-.9 3.207-.042.122c-.059.128-.117.261-.18.402-.488 1.058-1.097 2.066-1.699 3.039l-.04.07c-.37.598-.75 1.188-1.16 1.82l-.741 1.13c-.38.57-.75 1.14-1.118 1.718zM7.078 9.69c.031.18.07.36.133.559.168.578.43 1.2.77 1.871.43.848.93 1.68 1.417 2.48l.024.04c.289.468.617.988 1.027 1.629.211.332.43.652.653.98.27.398.539.82.808 1.23.2-.308.41-.62.61-.93.25-.37.492-.75.742-1.12.41-.621.777-1.2 1.136-1.79l.043-.07c.579-.941 1.168-1.922 1.63-2.922.05-.109.1-.207.14-.32l.84-2.988-.211-2-4.238-2.828-3.024.41-2.387 2.816zm0 0"
        ></path>
        <path
          fill="#533019"
          d="M14.75 11.18c-.04-.73-.398-1.051-.71-1.192.241-.136.5-.418.472-.968-.07-1.23-1.16-1.168-1.524-1.149l-1.097.059.257 4.91 1.16-.059c.454-.02 1.52-.082 1.442-1.601zm-1.809-2.52l.18-.012c.23-.007.348.153.36.493.019.34-.083.5-.31.52l-.183.01zm.29 3.352l-.11.008-.082-1.579.16-.011c.2-.008.461.058.5.77.031.69-.21.788-.469.812zm0 0"
        ></path>
        <path
          fill="#533019"
          d="M12.43 8.43c-.078-.72-.45-1.032-.782-1.149.211-.14.48-.43.422-.992-.129-1.219-1.218-1.098-1.582-1.059l-1.097.122.507 4.886 1.16-.129c.473-.05 1.532-.168 1.372-1.68zm-1.942-2.418l.184-.024c.226-.02.348.133.387.473.043.34-.047.508-.278.527l-.18.024zm.461 3.328l-.11.012-.167-1.57.156-.02c.203-.024.461.027.543.75.078.68-.152.797-.422.828zm0 0M25.578 27.781l-6.707-1.511-6.98 1.351-7.422-1.652 1.36-7.008-1.407-7.691 3.117.52-.21 1.222-1.368-.23 1.129 6.187-1.18 6.062 5.988 1.32 6.993-1.34 5.28 1.188-.69-6.699.718-5.898-4.988-1.774-2.39.672-.34-1.191 2.769-.778 6.3 2.239-.831 6.742zm0 0"
        ></path>
        <path
          fill="#533019"
          d="M11.828 20.34l-5.457-.762.18-1.219 5.258.73 6.5-1.058 5.882.86-.18 1.23-5.69-.84zm0 0"
        ></path>
        <path
          fill="#533019"
          d="M18.262 25.691l-.57-7.043.93-7.546 1.218.148-.91 7.422.558 6.918zm0 0M11.016 24.445l.191-4.758 1.238.051-.191 4.758zm0 0"
        ></path>
      </g>
    </svg>
  );
};

export default PinIcon;
